import { useNavigate } from 'react-router-dom';

const characters = [
  {
    id: 'pb1',
    name: 'Iru',
    label: 'Povos Indígenas',
    image: 'https://public.readdy.ai/ai/img_res/3b313d2e9e85f3f8a36f92b7507a8e84.jpg',
  },
  {
    id: 'pb2',
    name: 'Dandara',
    label: 'Quilombolas',
    image: 'https://readdy.ai/api/search-image?query=Single%20folk%20art%20illustrated%20character%20doll%20Afro-Brazilian%20quilombola%20woman%20standing%20full%20body%20pose%2C%20wearing%20vibrant%20colorful%20patchwork%20dress%20with%20yellow%20orange%20and%20green%2C%20head%20wrap%20turban%2C%20beaded%20jewelry%2C%20flat%20illustration%20boneco%20paper%20doll%20style%2C%20isolated%20on%20warm%20ochre%20plain%20background%2C%20hand-drawn%20naive%20folk%20art%20quality%2C%20warm%20earthy%20tones%20vibrant%20accents%2C%20centered%20figure&width=420&height=520&seq=boneco-pb2&orientation=portrait',
  },
  {
    id: 'pb3',
    name: 'Oxum',
    label: 'Matrizes Africanas',
    image: 'https://readdy.ai/api/search-image?query=Single%20folk%20art%20illustrated%20character%20doll%20Afro-Brazilian%20woman%20in%20ceremonial%20attire%20standing%20full%20body%20pose%2C%20white%20and%20gold%20layered%20skirt%20dress%2C%20colorful%20bead%20necklaces%20ekeke%2C%20hair%20wrapped%2C%20flat%20illustration%20boneco%20paper%20doll%20style%2C%20isolated%20on%20deep%20terracotta%20warm%20background%2C%20hand-drawn%20naive%20folk%20art%20quality%2C%20cultural%20religious%20African%20Brazilian%20elements%2C%20centered%20figure&width=420&height=520&seq=boneco-pb3&orientation=portrait',
  },
  {
    id: 'pb4',
    name: 'Cauã',
    label: 'Povos da Floresta',
    image: 'https://readdy.ai/api/search-image?query=Single%20folk%20art%20illustrated%20character%20doll%20Amazon%20forest%20river%20community%20person%20standing%20full%20body%20pose%2C%20wearing%20natural%20fiber%20woven%20clothing%2C%20holding%20medicinal%20plants%20and%20wooden%20paddle%2C%20simple%20earthy%20tones%20clothing%2C%20flat%20illustration%20boneco%20paper%20doll%20style%2C%20isolated%20on%20deep%20forest%20green%20plain%20background%2C%20hand-drawn%20naive%20folk%20art%20quality%2C%20nature%20botanical%20elements%2C%20centered%20figure&width=420&height=520&seq=boneco-pb4&orientation=portrait',
  },
  {
    id: 'pb5',
    name: 'Boi',
    label: 'Festas Populares',
    image: 'https://readdy.ai/api/search-image?query=Single%20folk%20art%20illustrated%20character%20doll%20Brazilian%20festive%20celebration%20person%20standing%20full%20body%20pose%2C%20wearing%20colorful%20bumba%20meu%20boi%20festive%20costume%20with%20orange%20yellow%20ribbons%20confetti%20hat%2C%20big%20smile%2C%20flat%20illustration%20boneco%20paper%20doll%20style%2C%20isolated%20on%20bright%20golden%20ochre%20plain%20background%2C%20hand-drawn%20naive%20folk%20art%20quality%2C%20festive%20joyful%20carnival%20elements%2C%20centered%20figure&width=420&height=520&seq=boneco-pb5&orientation=portrait',
  },
  {
    id: 'pb6',
    name: 'Mara',
    label: 'Educação Antirracista',
    image: 'https://readdy.ai/api/search-image?query=Single%20folk%20art%20illustrated%20character%20doll%20Brazilian%20teacher%20educator%20standing%20full%20body%20pose%2C%20wearing%20colorful%20casual%20clothes%20holding%20open%20book%20with%20cultural%20symbols%2C%20warm%20friendly%20expression%2C%20diverse%20representation%2C%20flat%20illustration%20boneco%20paper%20doll%20style%2C%20isolated%20on%20warm%20terracotta%20plain%20background%2C%20hand-drawn%20naive%20folk%20art%20quality%2C%20educational%20cultural%20elements%2C%20centered%20figure&width=420&height=520&seq=boneco-pb6&orientation=portrait',
  },
];

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex flex-col overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Brazilian%20folk%20art%20cultural%20scene%20panoramic%20with%20abstract%20geometric%20patterns%20inspired%20by%20indigenous%20quilombola%20African%20Brazilian%20cultures%2C%20handwoven%20textiles%20earthy%20terracotta%20ochre%20deep%20forest%20green%20warm%20tones%2C%20traditional%20crafts%20feathers%20beads%20wood%20carvings%20organic%20shapes%2C%20flat%20illustration%20style%20mural%20wide%20composition%2C%20rich%20warm%20cultural%20heritage%20celebration&width=1440&height=900&seq=hero-povos-bg&orientation=landscape"
          alt="Povos do Brasil"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A0A00]/75 via-[#1A0A00]/60 to-[#2D1A0A]/90"></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center pt-32 pb-10 px-6 text-center w-full">
        {/* Brand identity */}
        <div className="flex items-center gap-2 mb-6 justify-center">
          <div className="w-3 h-3 rounded-full bg-[#C85C2A]"></div>
          <div className="w-3 h-3 rounded-full bg-[#E8A42A]"></div>
          <div className="w-3 h-3 rounded-full bg-[#2D6A4F]"></div>
          <span className="text-xs font-bold text-[#E8A42A] tracking-widest uppercase ml-2">
            Editora LT apresenta
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white mb-5 leading-tight max-w-4xl mx-auto" style={{ fontFamily: '\'Playfair Display\', Georgia, serif' }}>
          Série <span style={{ color: '#E8A42A' }}>Povos do Brasil</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/85 mb-4 font-semibold max-w-2xl mx-auto">
          Conheça as histórias, saberes e culturas que formam a alma do Brasil
        </p>

        <p className="text-base text-white/65 mb-10 max-w-xl mx-auto leading-relaxed">
          6 cursos sobre povos indígenas, quilombolas, matrizes africanas, povos da floresta,
          festas populares e educação antirracista — para educadores que querem fazer a diferença.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-14">
          <button
            onClick={() => {
              const el = document.getElementById('povos-section');
              el?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="font-bold px-10 py-4 rounded-full text-base transition-all hover:opacity-90 hover:scale-105 whitespace-nowrap cursor-pointer text-white"
            style={{ background: 'linear-gradient(135deg, #C85C2A, #E8A42A)' }}
          >
            <i className="ri-play-circle-line mr-2"></i>
            Conhecer a Série
          </button>
          <button
            className="bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-bold transition-all border border-white/30 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-notification-3-line mr-2"></i>
            Quero ser avisado
          </button>
        </div>

        {/* Stats strip */}
        <div className="flex flex-wrap justify-center gap-8 mb-12">
          {[
            { value: '6', label: 'Cursos' },
            { value: '40h+', label: 'de conteúdo' },
            { value: '100%', label: 'Online' },
            { value: 'Certificado', label: 'Incluso' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl font-black" style={{ color: '#E8A42A' }}>{stat.value}</div>
              <div className="text-white/60 text-xs uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Characters strip pinned to bottom */}
      <div className="relative z-10 w-full">
        <div className="max-w-5xl mx-auto px-6 pb-0">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-4">
            {characters.map((char, i) => (
              <button
                key={char.id}
                onClick={() => navigate(`/curso/${char.id}`)}
                className="flex flex-col items-center gap-2 group cursor-pointer"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-white/20 group-hover:border-[#E8A42A] transition-all group-hover:scale-105">
                  <img
                    src={char.image}
                    alt={char.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="text-center pb-1">
                  <p className="text-white text-xs font-bold">{char.name}</p>
                  <p className="text-white/50 text-xs leading-tight">{char.label}</p>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Bottom color strip */}
        <div className="h-2 flex mt-4">
          <div className="flex-1 bg-[#C85C2A]"></div>
          <div className="flex-1 bg-[#E8A42A]"></div>
          <div className="flex-1 bg-[#2D6A4F]"></div>
          <div className="flex-1 bg-[#E8A42A]"></div>
          <div className="flex-1 bg-[#C85C2A]"></div>
        </div>
      </div>
    </section>
  );
}
